module.exports = "/images/Collect Custumer information2 1.svg?2a9546c893eda714fe0bab6e3f7de1f6";